import React from 'react';
import './Icon.css';

// Stroke-line icons (24×24 grid, Lucide-style shapes) in the style yasna uses
// for its buttons, so hoja's controls read as the same family.
const PATHS = {
  play: <path d="M7 4.5v15l12-7.5z" />,
  pause: <><rect x="6" y="4.5" width="4" height="15" rx="1" /><rect x="14" y="4.5" width="4" height="15" rx="1" /></>,
  // Rewind / forward (labelled "10s" by the button)
  rewind: <><path d="m11 17-5-5 5-5" /><path d="m18 17-5-5 5-5" /></>,
  forward: <><path d="m6 17 5-5-5-5" /><path d="m13 17 5-5-5-5" /></>,
  'skip-back': <><path d="M19 20 9 12l10-8z" /><path d="M5 19V5" /></>,
  'skip-forward': <><path d="m5 4 10 8-10 8z" /><path d="M19 5v14" /></>,
  'arrow-right': <><path d="M5 12h14" /><path d="m13 6 6 6-6 6" /></>,
  'arrow-up': <><path d="M12 19V5" /><path d="m6 11 6-6 6 6" /></>,
  'arrow-down': <><path d="M12 5v14" /><path d="m6 13 6 6 6-6" /></>,
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  'chevron-up': <path d="m18 15-6-6-6 6" />,
  // Replay: a counter-clockwise arrow
  'rotate-ccw': <><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /></>,
  // "More options": three dots
  more: <><circle cx="5" cy="12" r="1.3" /><circle cx="12" cy="12" r="1.3" /><circle cx="19" cy="12" r="1.3" /></>,
  'chevron-left': <path d="m15 18-6-6 6-6" />,
  'chevron-right': <path d="m9 18 6-6-6-6" />,
  plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  x: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
  timer: <><path d="M10 2h4" /><path d="M12 14l3-3" /><circle cx="12" cy="14" r="8" /></>,
  pencil: <><path d="M17 3a2.85 2.85 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5z" /><path d="m15 5 4 4" /></>,
  // Two chain links: "connect to the next one"
  link: <><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></>,
  download: <><path d="M12 3v12" /><path d="m7 10 5 5 5-5" /><path d="M5 21h14" /></>,
};

/** Icon — an inline SVG drawn with currentColor. Decorative: label the button. */
function Icon({ name, size = 18, strokeWidth = 2 }) {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      data-icon={name}
    >
      {PATHS[name]}
    </svg>
  );
}

export default Icon;
